import React from 'react';
import PropTypes from 'prop-types';
import { CardSelector, Button } from '@coog/components-library';

// inner component.
const Desk = ({ questionnaires = [], onClick }) => {
  const frontActions = questionnaire => (
    <Button
      eventEmitter={() => onClick({ action: 'create', questionnaire })}
      id={0}
      label="Selectionner"
      type={questionnaire?.theme ? questionnaire.theme : 'primary'}
    />
  );
  const getCard = questionnaire => ({
    back: questionnaire?.helper || questionnaire?.description,
    front: questionnaire?.description,
    theme: questionnaire?.theme || 'blue',
    titleFront: questionnaire?.title,
    frontActions: frontActions(questionnaire),
    height: 350,
  });
  const getCards = questionnaires => questionnaires.map(questionnaire => getCard(questionnaire));
  const _cards = getCards(questionnaires);

  return <CardSelector cards={_cards} cardsXAlign="left" cardsYAlign="top" lgColumns={4} mdColumns={3} smColumn={2} />;
};

Desk.propTypes = {
  questionnaires: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
      title: PropTypes.string,
      theme: PropTypes.string,
      helper: PropTypes.string,
    })
  ),
  onClick: PropTypes.func,
};

Desk.defaultProps = {
  questionnaires: [],
  onClick: () => {},
};

export default Desk;
